import TYPES from '../../../../../types';

// Application
import CreateBeneficiariesCommand
  from '@/modules/onboarding/beneficiary/application/commands/create-beneficiaries-command';
import SaveOnboardingSectionServiceBase
  from './save-onboarding-section-service-base';
import OnboardingCreateCustomerAgreementCommand
  from '@/modules/onboarding/customer-agreement/application/commands/onboarding-create-customer-agreement-command';

// Domain
import { SaveSectionResponseDto } from '../../../../domain/dtos/save-section-response-dto';
import { StoredPromiseDto } from '../../../../domain/dtos/stored-promise-dto';
import Inject from '@/modules/shared/domain/di/inject';

export default class SaveBeneficiariesSectionService extends SaveOnboardingSectionServiceBase {
  @Inject(TYPES.ONBOARDING_CREATE_BENEFICIARIES_COMMAND)
  private readonly onboardingCreateBeneficiariesCommand!: CreateBeneficiariesCommand;

  @Inject(TYPES.ONBOARDING_CREATE_CUSTOMER_AGREEMENT_COMMAND)
  // eslint-disable-next-line max-len
  private readonly on_boarding_create_customer_agreement_command!: OnboardingCreateCustomerAgreementCommand;

  async execute(): SaveSectionResponseDto {
    const beneficiaries_step = await this.get_on_boarding_step_query.execute('beneficiaries');

    const base_promises = [
      {
        id: 'onboarding_create_beneficiaries_command',
        command: this.onboardingCreateBeneficiariesCommand,
        data: beneficiaries_step.payload.beneficiaries,
      },
      {
        id: 'onboarding_create_customer_agreement-0',
        command: this.on_boarding_create_customer_agreement_command,
        data: beneficiaries_step.payload.agreements[0],
      },
    ];

    const promises = (await this.filteredPromises(base_promises, 'beneficiaries')).map(
      (item) => item.command.execute(item.data),
    );

    return new Promise((resolve) => {
      Promise.allSettled(promises)
        .then((results) => {
          const rejected_promises: Array<StoredPromiseDto> = [];
          results.forEach((item, index) => {
            if (item.status === 'rejected') {
              rejected_promises.push({
                id: base_promises[index].id,
                error: item.reason.message.toLowerCase().split(' ').join('_'),
              });
            }
          });

          resolve({ beneficiaries: rejected_promises });
        });
    });
  }
}
